// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZL3e","left":"styles_left__ZAW0N","desktopActions":"styles_desktopActions__10x7t","title":"styles_title__3wFgN"};